import { getAccountFeatureFlagDefinitions, getAccountFeatureFlags } from "@/services/AccountService"

let definitionsRequest = null

export const fetchAccountFeatureFlags = async ({ commit }, accountKey) => {
  const { flags } = await getAccountFeatureFlags(accountKey)

  commit("setAccountFlags", flags)

  return flags
}

export const fetchFeatureFlagDefinitions = async ({ state, commit }) => {
  if (state.definitions) return state.definitions

  if (!definitionsRequest) {
    definitionsRequest = getAccountFeatureFlagDefinitions().finally(() => {
      definitionsRequest = null
    })
  }

  const definitions = (await definitionsRequest)?.definitions || []

  commit("setDefinitions", definitions)

  return definitions
}
